// @ts-nocheck
import { mediumScreenQuery } from "./Browser";
import { interactivityRegistration } from "./Charta";
import { DomQuery, HtmlClassSwitch, WithClass } from "./Dom";
import { AvailableSizeChangedEvent, DataChangedEvent, distributeEvent, getEvent } from "./Event";
import { NavigationEvent } from "./WebApp.Page";
import { WebPageComponent } from "./WebSite.Page.Component";

export class Task extends WebPageComponent {
  constructor(element) {
    super(element);

    this.parent = null;
    this.count = null;
    this.children = null;
    this.expanded = null;

    this.determineElements();
    this.attachEventHandlers();
  }

  determineElements() {
    const query = new DomQuery(this.element);

    this.parent = query.getDescendant(WithClass("Parent"));
    this.count = query.getDescendant(WithClass("Count"));
    this.children = query.getDescendant(WithClass("Children"));

    if (this.children !== null) {
      this.expanded = new HtmlClassSwitch(this.element, "Expanded");
      this.expanded.setStatus(false);
    }
  }

  attachEventHandlers() {
    if (this.count !== null && this.children !== null) {
      this.count.onclick = (event) => {
        this.iconClicked(getEvent(event));
      };
    }
  }

  iconClicked(event) {
    this.expanded.toggle();
    getEvent(event).stopHandling();
  }
}

export class NotificationCenterComponent extends WebPageComponent {
  constructor(element) {
    super(element);

    this.updatingSwitch = new HtmlClassSwitch(element, "Updating");
    this.uri = element.dataset.Uri;
    this.renderTime = element.dataset.RenderTime;
    this.toggleSwitch = new HtmlClassSwitch(element, "Collapsed");

    this.determineElements();
    this.attachToolbarEventHandlers();
    this.initialize();

    mediumScreenQuery.addEventListener(
      "change",
      (event) => {
        if (event.matches && !this.toggleSwitch.getStatus())
          this.toggle();
      }
    );

    if (mediumScreenQuery.matches && !this.toggleSwitch.getStatus())
      this.toggle();
  }

  determineElements() {
    const query = new DomQuery(this.element);

    this.contents = query.getChild(WithClass("Contents"));
    this.widgets = new DomQuery(this.contents).getChildren(WithClass("widget"));

    this.toggleButton = query.getDescendant(WithClass("Toggle"));
    this.refreshButton = query.getDescendant(WithClass("Refresh"));

    if (this.element.dataset.Count > 0)
      this.toggleButton.childNodes[0].innerHTML = this.element.dataset.Count;
  }

  handleEvent(event) {
    if (event instanceof DataChangedEvent || event instanceof NavigationEvent)
      this.invalidate();
    else
      super.handleEvent(event);
  }

  async validate() {
    this.refresh();
  }

  initialize() {
    if (this.renderTime === "Deferred")
      this.refresh();
  }

  async toggle() {
    if (!this.updatingSwitch.getStatus()) {
      this.updatingSwitch.setStatus(true);

      try {
        this.toggleSwitch.toggle();
        const state = { Collapsed: this.toggleSwitch.getStatus() };

        setTimeout(
          () => distributeEvent(new AvailableSizeChangedEvent()),
          500
        );

        await fetch(
          this.uri,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(state)
          }
        )
      }
      catch (error) {
        console.log(error);
      }
      finally {
        this.updatingSwitch.setStatus(false);
      }
    }
  }

  reload(html) {
    const container = document.createElement("div");
    container.innerHTML = html;

    const notificationCenter = container.firstChild;

    if (notificationCenter.classList.contains("NotificationCenter")) {
      interactivityRegistration.detach(this.element);
      this.element.parentNode.replaceChild(notificationCenter, this.element);
      interactivityRegistration.attach(notificationCenter);
    }
  }

  refresh() {
    if (!this.updatingSwitch.getStatus())
      this.refreshNotificationCenter();
  }

  async refreshNotificationCenter() {
    this.updatingSwitch.setStatus(true);

    try {
      const response = await fetch(
        this.uri,
        {
          method: "GET",
          headers: {
            "Accept": "text/html"
          }
        }
      );

      if (response.ok) {
        const text = await response.text();
        this.reload(text);
      }
    }
    catch (error) {
      console.log(error);
    }
    finally {
      this.updatingSwitch.setStatus(false)
    }
  }

  attachToolbarEventHandlers() {
    this.toggleButton.addEventListener("click", (event) => this.toggle());
    this.refreshButton.addEventListener("click", (event) => this.refresh());
  }
}

interactivityRegistration.register("Task", function (element) { return new Task(element); });
interactivityRegistration.register("NotificationCenter", function (element) { return new NotificationCenterComponent(element); });
